// The following are required to detect if the user is logged in, so we can skip recording events
// - Request BaseURL: "app.hubspot[qa].com/api" so that the hubspotapi-csrf cookie can be sent
// - Portal ID as a query param
// - credentials: 'include' so that cross-site cookies are sent
function trackQuoteEvent(appBaseUrl, portalId, requestBody, eventRoute) {
  void fetch(`${appBaseUrl}/api/quote-tracking-events-external/v1/${eventRoute}?portalId=${portalId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody),
    credentials: 'include'
  }).catch(error => {
    console.log('hs-quote-tracking failed to track event', {
      error
    });
  });
}
export function trackQuoteView(appBaseUrl, portalId, requestBody) {
  trackQuoteEvent(appBaseUrl, portalId, requestBody, 'view');
}
export function trackQuotePrint(appBaseUrl, portalId, requestBody) {
  trackQuoteEvent(appBaseUrl, portalId, requestBody, 'print');
}